import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import LimeLanding from "@/pages/LimeLanding";
import PricingPage from "@/pages/PricingPage";
import AdminApp from "@/pages/AdminApp";

// Re-fire Meta Pixel PageView on client-side route changes
function PixelRouteTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [location.pathname]);
  return null;
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <PixelRouteTracker />
        <Routes>
          <Route path="/" element={<LimeLanding />} />
          <Route path="/book/:packageId" element={<LimeLanding />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/admin/*" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
